import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Tooltip from 'react-tooltip';
import { withFormsy } from 'formsy-react';

class Input extends React.Component {
    render() {
        const {
            name,
            type,
            disabled,
            placeholder,
            maxLength,
            minLength,
            disableAutoComplete,
            onBlur,
            onMouseEnter,
            onMouseLeave,
            onKeyDown,
            customClassNames,
            customValidationMessage,
            value,
            onChange,
            fullColumn,
            showError,
            showTooltip,
            toolTipMessage,
            getErrorMessage,
            isFormSubmitted,
            validations,
            required,
            isValid
        } = this.props;

        const inputType = type || 'text';
        // Required as div become uneven when message appended
        const fillerText = 'invisible filler text';

        const inputPlaceholder = required ? `* ${placeholder}` : placeholder || '';

        /* Validation states */
        let rootValidationClassname = '';
        const hasValidations = validations && Object.keys(validations).length > 0;

        if (!disabled && ((hasValidations && showError()) || customValidationMessage)) {
            rootValidationClassname += 'error';
        }

        if (isFormSubmitted()) {
            rootValidationClassname = isValid() && !customValidationMessage ? 'success' : 'error';
        }

        const messageClassNames = classNames('input-message');
        const inputClassNames = classNames('input', name);
        const autoComplete = disableAutoComplete ? 'off' : 'on';
        const filledClass = value ? 'filled' : '';

        const inputElement = (
            <input
                className={inputClassNames}
                type={inputType}
                maxLength={maxLength}
                minLength={minLength}
                autoComplete={autoComplete}
                name={name}
                disabled={disabled}
                value={value}
                onBlur={onBlur}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onChange={onChange}
                onKeyDown={onKeyDown}
            />
        );

        const toolTipElement = showTooltip && (
            <div className="custom-tooltip" data-msg={toolTipMessage}>
                <a data-tip data-for={`${name}-tip`} className={classNames('info-badge', { disabled })}>
                    i
                </a>
                <Tooltip className="display-name-tooltip" id={`${name}-tip`}>
                    <span className="content" dangerouslySetInnerHTML={{ __html: toolTipMessage }} />
                </Tooltip>
            </div>
        );

        const errorMessage = getErrorMessage();

        const renderInputElement = (
            <div className={classNames('form-field form-field--custom', rootValidationClassname, filledClass)}>
                {inputElement}
                {toolTipElement}
                <label htmlFor="email" className="control-label">
                    {inputPlaceholder.toUpperCase()}
                </label>
                <div className={messageClassNames} dangerouslySetInnerHTML={{ __html: errorMessage || customValidationMessage || fillerText }} />
            </div>
        );

        return (
            <div className={classNames('form-field-wrapper', customClassNames)}>
                {renderInputElement}
                {fullColumn && <div className="clearfix" />}
            </div>
        );
    }

    static propTypes = {
        name: PropTypes.string,
        type: PropTypes.string,
        disabled: PropTypes.bool,
        maxLength: PropTypes.number,
        minLength: PropTypes.number,
        onBlur: PropTypes.func,
        onMouseLeave: PropTypes.func,
        onMouseEnter: PropTypes.func,
        onChange: PropTypes.func,
        onKeyDown: PropTypes.func,
        placeholder: PropTypes.string,
        fullColumn: PropTypes.bool,
        showTooltip: PropTypes.bool,
        toolTipMessage: PropTypes.string,
        disableAutoComplete: PropTypes.bool,
        customClassNames: PropTypes.string,
        customValidationMessage: PropTypes.string,
        value: PropTypes.string,
        showError: PropTypes.func,
        getErrorMessage: PropTypes.func,
        validations: PropTypes.object,
        isFormSubmitted: PropTypes.func,
        required: PropTypes.bool,
        isValid: PropTypes.func
    };

    static defaultProps = {
        name: '',
        type: '',
        disabled: false,
        maxLength: 100,
        minLength: 0,
        onBlur: () => {},
        onMouseLeave: () => {},
        onMouseEnter: () => {},
        onChange: () => {},
        onKeyDown: () => {},
        placeholder: '',
        fullColumn: false,
        showTooltip: false,
        toolTipMessage: '',
        disableAutoComplete: false,
        customClassNames: '',
        customValidationMessage: '',
        value: '',
        showError: () => {},
        getErrorMessage: () => {},
        validations: {},
        isFormSubmitted: () => {},
        required: false,
        isValid: () => {}
    };
}

export default withFormsy(Input);
